import { useTranslation } from 'next-i18next';
import { DSLinkButton } from '@stihl-design-system/components';

import { link } from '@phoenix/core/frontend/shared/util/navigation/link.utils';
import { BaseBanner } from '@phoenix/team-m/dashboard/frontend/shared/components/base-banner';
import { GA } from '@phoenix/core/frontend/shared/feature/google-analytics/ga';
import { useImpressionEvent } from '@phoenix/core/frontend/shared/util/hooks/use-impression-event';

export const MyBenefitsBanner: React.FC = () => {
  const { t } = useTranslation();
  const BASE_EVENT_NAME = 'mystihl_banner_my_benefits';
  const headline = t('dashboard_myBenefitsBannerDefault_header');
  const description = t('dashboard_myBenefitsBannerDefault_description');

  const linkButton = {
    url: link('tool-shed/my-benefits'),
    label: t('dashboard_myBenefitsBanner_buttonLabel'),
  };

  const trackingData = {
    id: 'dashboard_my_benefits_banner',
    headline,
    description,
    button_text: linkButton?.label,
    link_url: linkButton?.url,
  };

  const trackEvent = () =>
    GA.sendEvent({
      event_name: `${BASE_EVENT_NAME}_link_click`,
      ...trackingData,
    });

  const ref = useImpressionEvent(() => GA.sendEvent({ event_name: `${BASE_EVENT_NAME}_impression`, ...trackingData }));

  return (
    <BaseBanner
      ref={ref}
      id="my-benefits-banner"
      backgroundImg="benefits-banner.jpg"
      imageTags={['imagesDashboard']}
      headline={headline}
      description={description}
    >
      {linkButton && (
        <DSLinkButton href={linkButton.url} onClick={trackEvent} className="mt-5 w-full tablet:w-fit">
          {linkButton.label}
        </DSLinkButton>
      )}
    </BaseBanner>
  );
};

export default MyBenefitsBanner;
